import { render, staticRenderFns } from "./Notifications.component.vue?vue&type=template&id=dd2f4a9c&scoped=true&"
import script from "./Notifications.component.vue?vue&type=script&lang=js&"
export * from "./Notifications.component.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.component.vue?vue&type=style&index=0&id=dd2f4a9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2f4a9c",
  null
  
)

export default component.exports